import React, {useEffect, useState, useRef} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faFaceSmile, faFaceSadTear } from '@fortawesome/free-solid-svg-icons'; 
import { useReactToPrint} from 'react-to-print'
import '../App.css';


function Boleta (props)
{

    const [order, setOrder] = useState();
    const [orderStatus, setOrderStatus] = useState();
    const [diacontable, setDiaContable] = useState();
    const [monto, setMonto] = useState();
    const [codigoautorizacion, setCodigoAutorizacion] = useState();
    const [numeroorden, seNumeroOrden] = useState();
    const [tarjeta, setTarjeta] = useState();
    const [tipopago, setTipoPago] = useState();
    const [fechaTransaccion, setFechaTransaccion] = useState();
    const [orderMessage, setOrderMessage] = useState();
    const [statusOrdenIcon, setStatusOrdenIcon] = useState(null);
    const [statusOrdenClass, setStatusOrdenClass] = useState('');    
    const [statusOrdenHead, setStatusOrdenHead] = useState('');   
    const [transaccionAutorizada, setTransaccionAutorizada] = useState(true);  
    const boletaRef = useRef(); // Referencia para el componente que se imprimirá

    useEffect(() => {
        let ordervar = JSON.parse(window.localStorage.getItem('MY_APP_STATE_BOLETA')) 
        setOrder(ordervar)
        //Limpia la variable con la info de boleta
        localStorage.setItem('MY_APP_STATE_BOLETA', '');

        setOrderStatus(ordervar.DetailTransaction.status)
        setDiaContable(ordervar.DetailTransaction.accounting_date)
        setMonto(ordervar.DetailTransaction.amount)
        setCodigoAutorizacion(ordervar.DetailTransaction.authorization_code)
        seNumeroOrden(ordervar.DetailTransaction.buy_order)
        setTarjeta(ordervar.DetailTransaction.card_detail.card_number)
        if(ordervar.DetailTransaction.payment_type_code == 'VD'){
            setTipoPago('Venta débito')
        }else if(ordervar.DetailTransaction.payment_type_code == 'VN'){
            setTipoPago('Venta normal')
        }else if(ordervar.DetailTransaction.payment_type_code == 'VC'){
            setTipoPago('Venta en cuotas')
        }else if(ordervar.DetailTransaction.payment_type_code == 'SI'){
            setTipoPago('3 cuotas sin interés')
        }else if(ordervar.DetailTransaction.payment_type_code == 'S2'){
            setTipoPago('2 cuotas sin interés')
        }else if(ordervar.DetailTransaction.payment_type_code == 'NC'){
            setTipoPago('Cuotas sin interés')
        }else{
            setTipoPago('venta prepago')
        }
        
        setFechaTransaccion(ordervar.DetailTransaction.transaction_date)
        setOrderMessage(ordervar.Message)

        if(ordervar.DetailTransaction.status == 'AUTHORIZED')
        {
            setStatusOrdenIcon(<FontAwesomeIcon icon={faCheck} color='silver' />);
            setStatusOrdenClass('bg-green-500')
            setStatusOrdenHead('Colegio Aleman: Compra autorizada')
            setTransaccionAutorizada(true)
        }
        else if(ordervar.DetailTransaction.status == 'FAILED')
        {
            setStatusOrdenIcon(<FontAwesomeIcon icon={faTimes} color='silver'  />);
            setStatusOrdenClass('bg-red-500')
            setStatusOrdenHead('Colegio Aleman: Compra no autorizada')
            setTransaccionAutorizada(false)
        }
        else if(ordervar.DetailTransaction.status == 'Created')
        {
            setStatusOrdenIcon(<FontAwesomeIcon icon={faTimes} color='silver'  />);
            setStatusOrdenClass('bg-yellow-500')
            setStatusOrdenHead('Colegio Aleman: Compra no ejecutada')
            setTransaccionAutorizada(false)
        }

    }, []);

    // Configuración del hook para imprimir el componente
    const handlePrint = useReactToPrint({
        content: () => boletaRef.current,
        documentTitle: 'Comprobante de Pago',
        onBeforeGetContent: () => console.log('Generando PDF...')
    });
         
    return(
        <div className='container'>
            <div className='row'>

            <div ref={boletaRef} className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6 space-y-4 relative">

{/* Header - Estado de la orden */}
<div className="flex items-center justify-between border-b pb-4">
  <div className={`p-2 rounded-full ${statusOrdenClass} w-12 h-12 flex items-center justify-center`}>
    {statusOrdenIcon}
  </div>
  <div className="ml-4 text-xl font-semibold text-gray-800">
    {statusOrdenHead}
  </div>
</div>

{/* Detalles de la boleta */}
<div className="space-y-4">
  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Estado :</div>
    <div className="w-1/3 pl-4 text-gray-800">{transaccionAutorizada ? "Autorizada" : "No Autorizada"}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Monto :</div>
    <div className="w-1/3 pl-4 text-gray-800">$ {monto || ''}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Mes/Dia contable :</div>
    <div className="w-1/3 pl-4 text-gray-800">{diacontable || ''}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Últimos dígitos tarjeta :</div>
    <div className="w-1/3 pl-4 text-gray-800">{tarjeta || ''}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Medio de pago :</div>
    <div className="w-1/3 pl-4 text-gray-800">{tipopago || ''}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Fecha transacción :</div>
    <div className="w-1/3 pl-4 text-gray-800">{fechaTransaccion || ''}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Número de orden :</div>
    <div className="w-1/3 pl-4 text-gray-800">{numeroorden || ''}</div>
  </div>

  <div className="flex justify-start">
    <div className="w-2/3 text-right text-gray-600 font-medium">Código de autorización :</div>
    <div className="w-1/3 pl-4 text-gray-800">{codigoautorizacion || ''}</div>
  </div>
</div>

{/* Icono de marca de agua (transacción autorizada o no autorizada) */}
<div className={`absolute top-0 right-0 w-32 h-32 opacity-10 z-10 ${transaccionAutorizada ? "text-green-500" : "text-red-500"} hidden md:block`}>
  <FontAwesomeIcon icon={transaccionAutorizada ? <FontAwesomeIcon icon={faFaceSmile} /> : <FontAwesomeIcon icon={faFaceSadTear} />} className="w-full h-full" />
</div>

{/* Icono de marca de agua que se mueve al pie en pantallas pequeñas */}
<div className={`absolute bottom-0 right-0 w-32 h-32 opacity-10 z-10 ${transaccionAutorizada ? "text-green-500" : "text-red-500"} md:hidden`}>
  <FontAwesomeIcon icon={transaccionAutorizada ? faCheck : faTimes} className="w-full h-full" />
</div>

</div>

        {/* Botón para descargar el comprobante como PDF */}
        <div className="mt-4 flex justify-center">
          <button
            onClick={handlePrint}
            className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500">
            Descargar PDF
          </button>
        </div>


            </div>
        </div>        
    )
}
export default Boleta